export default "__VITE_ASSET__C4OL329C__"